import { getShippingEstimateQuantity } from '@vtex/estimate-calculator'
import { parcelify } from '@vtex/delivery-packages/dist/parcel'
import sortBy from 'lodash/sortBy'

import type { OrderForm } from '../core/requests/checkout'
import type { Package, PackageOptions } from '../core/typings'

export function getOrderAsPackages(
  orderForm: OrderForm | undefined,
  options: PackageOptions | undefined
): Package[] {
  return sortBy(parcelify(orderForm, options), [
    (pkg: Package) => getShippingEstimateQuantity(pkg?.shippingEstimate),
  ])
}
